import { Button, Icon } from "@legal-500/legal500-design-system";
import { useEffect, useState } from "react";
import type { Package } from "../../../api/packages.service";
import { FeaturePicker } from "../../FeaturePicker";
import styles from "../PackageVersionModal.module.css";

export type Step2FeatureSelectionProps = {
  package: Package;
  initialFeatureCodes: string[];
  onReviewChanges: (selectedFeatureCodes: string[]) => void;
  onCancel: () => void;
};

export function Step2FeatureSelection({
  package: pkg,
  initialFeatureCodes,
  onReviewChanges,
  onCancel,
}: Step2FeatureSelectionProps) {
  const [selectedFeatureCodes, setSelectedFeatureCodes] = useState<string[]>(initialFeatureCodes);
  const nextVersion = pkg.version + 1;

  useEffect(() => {
    setSelectedFeatureCodes(initialFeatureCodes);
  }, [initialFeatureCodes]);

  function handleContinue() {
    onReviewChanges(selectedFeatureCodes);
  }

  return (
    <>
      <div className={styles.modalHeader}>
        <div className={styles.headerContent}>
          <div className={styles.iconWrapper} aria-hidden="true">
            <Icon icon="copy" size="large" />
          </div>
          <h2 id="version-package-title" className={styles.modalTitle}>
            Select Features for Version {nextVersion}
          </h2>
        </div>
        <button
          className={styles.modalCloseButton}
          onClick={onCancel}
          aria-label="Close modal"
          type="button"
        >
          <Icon icon="cross" size="small" />
        </button>
      </div>

      <div className={styles.modalBody}>
        <p className={styles.versionMessage}>Starting from version {pkg.version} features</p>

        <div className={styles.featurePickerWrapper}>
          <FeaturePicker
            selectedFeatureCodes={selectedFeatureCodes}
            onChange={setSelectedFeatureCodes}
            columns={{ mobile: 1, tablet: 2, desktop: 2 }}
            compact={true}
          />
        </div>
      </div>

      <div className={styles.modalFooter}>
        <Button variant="outlined" color="default" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleContinue}
          className={styles.primaryButton}
        >
          Review Changes
        </Button>
      </div>
    </>
  );
}
